import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/app-setting/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import { drapcodeIcon } from '../../common/custom/icon-library';
import ToggleButton from '../../common/ui/ToggleButton';
import CustomLoader from '../common/CustomLoader';
import { loaderScreenValidation } from '../../common/utils/validate';
import { ParentContentCardMultiHeader } from '../common/ParentContentCardMultiHeader';
import { showAlertHtml } from '../../common/utils/alert';

class LoaderScreen extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    isEnabled: true,
  };

  componentDidMount() {
    this.loadProjectSettings();
  }

  loadProjectSettings = async () => {
    const { match, actions, appSetting } = this.props;
    const { projectId, version } = match.params;

    await actions.loadProjectDetailAppSetting({ projectId, version });
    const projectDetail = appSetting.projectDetail;
    if (projectDetail) {
      const loaderScreen = projectDetail.loaderScreen;
      if (loaderScreen) {
        this.setState({ isEnabled: loaderScreen.isEnabled });
      }
    }
  };

  handleToggle = async () => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const newStatus = !this.state.isEnabled;

    const preConfirm = async () => {
      this.setState({ isEnabled: newStatus });
      await actions.loaderScreenSettings({ projectId, version, data: { isEnabled: newStatus } });
    };

    showAlertHtml(
      newStatus
        ? 'Enable Loader?<br/><br/><span>Do you want to enable the loader?</span>'
        : 'Disable Loader?<br/><br/><span>Do you want to disable the loader?</span>',
      preConfirm,
      newStatus ? 'Yes, Enable' : 'Yes, Disable',
      newStatus ? 'info' : 'warning',
    );
  };
  handleSubmit = async (values, { setSubmitting }) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    await actions.loaderScreenSettings({
      projectId,
      version,
      data: values,
    });
    setSubmitting(false);
  };

  render() {
    const { appSetting, loaderScreenSettingsPending, match } = this.props;
    const { projectId, version } = match.params;
    const projectDetail = appSetting.projectDetail;
    const { isEnabled } = this.state;

    if (!projectDetail) {
      return null;
    }

    const loaderScreen = projectDetail.loaderScreen || {};
    const { opacity } = loaderScreen;
    const actionText = Object.keys(loaderScreen).length > 0 ? 'Update' : 'Save';

    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab="loaderScreen" projectDetail={projectDetail} />

        <div className="col-12 drapcode">
          <div className="row mx-auto">
            <ParentContentCardMultiHeader
              title="Loader Screen"
              bgColor="drapcode-violet"
              icon="loaderScreen"
              projectId={projectId}
              version={version}
              CtaComponent={
                <div className="d-flex align-items-center">
                  <ToggleButton
                    name="isEnabled"
                    title={isEnabled ? 'Enabled' : 'Disabled'}
                    isChecked={isEnabled}
                    onChange={this.handleToggle}
                  />
                </div>
              }
            >
              {isEnabled ? (
                <Formik
                  initialValues={{
                    opacity,
                  }}
                  enableReinitialize={true}
                  validationSchema={loaderScreenValidation}
                  onSubmit={this.handleSubmit}
                >
                  {({ values, setFieldValue, isSubmitting }) => (
                    <Form>
                      <div className="row align-items-center mb-3">
                        <div className="col-6">
                          <FormFieldWithLabel label="Opacity">
                            <Field
                              type="number"
                              name="opacity"
                              className="form-control form-control-sm"
                              placeholder="Enter opacity (0 - 1)"
                              step="0.1"
                            />
                          </FormFieldWithLabel>
                          <ErrorMessage
                            name="opacity"
                            component="div"
                            className="text-danger mt-1 ml-5"
                          />
                        </div>
                      </div>
                      <div className="mt-2 text-right">
                        <button
                          type="submit"
                          className="btn btn-theme-submit btn-md"
                          disabled={isSubmitting || loaderScreenSettingsPending}
                        >
                          <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;
                          {actionText}
                          {loaderScreenSettingsPending ? <CustomLoader loading color="#fff" /> : ''}
                          &nbsp;
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              ) : (
                ''
              )}
            </ParentContentCardMultiHeader>
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
    loaderScreenSettingsPending: state.appSetting.loaderScreenSettingsPending,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoaderScreen);
